<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Отчёт возврат поставщикам
          <v-divider class="mx-2" inset vertical></v-divider>
          <export-json-excel
              :data="vozvratho"
              :fields="export_sumfurush_fields"
              :worksheet="'Возврат поставщикам '"
              :name="'Возврат поставщикам'  ">
                <v-icon  color="success" >
                  mdi-microsoft-excel
                  </v-icon>
            </export-json-excel>


        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">
              <v-menu class="m-2"
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :return-value.sync="date1"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date1"
                  label="Дата 1"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date1"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_vozvratho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>




            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Поставщик"
            hide-details
            solo
            prepend-icon="mdi-filter-menu-outline"
            :items="firmaho"
            item-text="nom"
            item-value="id_firma"
            class="m-4"
            @change="get_vozvratho_firma"
            @click:clear="get_vozvratho"
            v-model="id_firma" />


          </v-col>

          <v-col cols="12" md="3">

              <v-menu
              ref="menu2"
              v-model="menu2"
              :close-on-content-click="false"
              :return-value.sync="date2"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="date2"
                  label="Дата 2"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  solo
                  hide-details
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="date2"
                no-title
                scrollable
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu2 = false"
                >
                  Отмена
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="get_vozvratho"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>




          </v-col>
          <v-col cols="12" md="4">

              <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="searching"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table dense
        :headers="headers"
        :items="vozvratho"
        item-key="id_vozvratp"
        class="elevation-1"
        :loading="loading"
        loading-text="Загрузка. Пожалуйста подождите"
          :footer-props="{
              'items-per-page-options': [ 7, 20, 50, 100],
              'items-per-page-text':'Строк на странице',
          }"
          no-data-text="Данные отсутствуют в таблице"
        :search="searching">




          <template slot="body.append">
              <tr>
                  <th ></th>
                  <th >Итого</th>
                  <th >{{Number( sumField('mikdor')).toFixed(2) }}</th>
                  <th > </th>
                  <th >{{Number( sumField('summa')).toFixed(2) }}</th>
                  <th ></th>
                  <th ></th>
                  <th ></th>
                  <th ></th>
              </tr>
          </template>

        </v-data-table>
      </v-container>



      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>

export default {

data: () => ({

  searching: "",
  search: "",
    id_firma: "",

      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,




    headers: [

    { text: "№", value: "id_vozvratp" },
    { text: "Наименование", value: "nom_mol" },
    { text: "Кол-во", value: "mikdor" },
    { text: "Цена", value: "narkh" },
    { text: "Сумма", value: "summa" },
    { text: "Поставщик", value: "nom" },
    { text: "Пользователь", value: "nom_user" },
    { text: "Дата", value: "sana" },
    { text: "Комментарий", value: "comment"},


    ],

snack: false,
    snackColor: '',
    snackText: '',

loading: false,
vozvratho: [],
firmaho: [],
vozvrat: {},
vozvrat_list: [],

furush_card: false,
sumfurush_card: true,


export_sumfurush_fields: [

  {
      'title': '№',
      'name': 'id_vozvratp',
      'width': '20',
      'type': 'Number',
      },
      {
      'title': 'Наименование',
      'name': 'nom_mol',
      'width': '35'

      },

      {
      'title': 'Кол-во',
      'name': 'mikdor',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Цена',
      'name': 'narkh',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Сумма',
      'name': 'summa',
      'type': 'float',
      'width': '15'
      },
      {
      'title': 'Поставщик',
      'name': 'nom',
      'width': '35'
      },
      {
      'title': 'Пользователь',
      'name': 'nom_user',
      'width': '35'
      },

      {
      'title': 'Дата',
      'type': 'Date',
      'name': 'sana',
      'width': '20'
      },
      {
      'title': 'Комментарий',
      'name': 'comment',
      'width': '35'
      },

],


}),

mounted(){
  this.get_firmaho();
  this.get_vozvratho();

},

methods: {
  sumField(key) {
  return  this.vozvratho.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },



  get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },



  get_vozvratho(){
          this.vozvratho = [];
          this.$refs.menu.save(this.date1)
          this.$refs.menu2.save(this.date2)
          this.loading = true;
        axios.post('/api/get_vozvrathop', { start: this.date1, end: this.date2},
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                            this.loading = false;
                            this.vozvratho = response.data.vozvrat;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения peremeshenies"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        console.log(error.response.data.message);
                        // this.snack = true
                        // this.snackColor = 'error'
                        // this.snackText = error.response.data.message;
                        //     setTimeout(() => {
                        //         this.snack = false;
                        //     }, 2000);
                    });
                  },

                  get_vozvratho_firma(){

          this.vozvratho = [];
      //    this.$refs.menu.save(this.date1)
       //   this.$refs.menu2.save(this.date2)
          this.loading = true;
          axios.post('/api/get_vozvrathop_firma', { start: this.date1,
                                            end: this.date2,
                                            id_firma: this.id_firma},
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){

                            this.loading = false;
                            this.vozvratho = response.data.vozvrat;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения filter firma"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                       // console.log(error.response.data.message);
                        // this.snack = true
                        // this.snackColor = 'error'
                        // this.snackText = error.response.data.message;
                        //     setTimeout(() => {
                        //         this.snack = false;
                        //     }, 2000);
                    });
                  },









  back_to_sumfurush(){
      this.furush_card = false;
      this.sumfurush_card = true;
  },



},



}
</script>

<style  scoped>

</style>



